import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isDesktop: boolean
}

export const Container = styled(ButtonPlain)<Props>`
	display: flex;
	align-items: center;
	font-size: ${helpers.font.size.small};
	background-color: ${helpers.color.primaryTranslucent};
	color: ${helpers.color.textContrastMuted};
	border-radius: 4px;
	border: 1px solid ${helpers.color.primaryAccent};
	padding: 10px;
	min-width: ${({ isDesktop }) => (isDesktop ? '260px' : 'unset')};
	column-gap: 8px;
	line-height: 1;
	transition: background-color 0.2s;

	&:is(:focus-visible, :hover) {
		background-color: ${helpers.color.primaryLightened};
		color: ${helpers.color.text};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}
`
